/* tslint:disable */
import { Injectable, Inject, Optional } from '@angular/core';
import { Http } from '@angular/http';
import { SDKModels } from './SDKModels';
import { BaseLoopBackApi } from '../core/base.service';
import { LoopBackConfig } from '../../lb.config';
import { LoopBackAuth } from '../core/auth.service';
import { LoopBackFilter, } from '../../models/BaseModels';
import { JSONSearchParams } from '../core/search.params';
import { ErrorHandler } from '../core/error.service';
import { Observable } from 'rxjs/Rx';
import { Entityrecord } from '../../models/Entityrecord';
import { SocketConnection } from '../../sockets/socket.connections';


/**
 * Api services for the `Entityrecord` model.
 */
@Injectable()
export class EntityrecordApi extends BaseLoopBackApi {

  constructor(
    @Inject(Http) protected http: Http,
    @Inject(SocketConnection) protected connection: SocketConnection,
    @Inject(SDKModels) protected models: SDKModels,
    @Inject(LoopBackAuth) protected auth: LoopBackAuth,
    @Inject(JSONSearchParams) protected searchParams: JSONSearchParams,
    @Optional() @Inject(ErrorHandler) protected errorHandler: ErrorHandler
  ) {
    super(http, connection, models, auth, searchParams, errorHandler);
  }

  /**
   * Fetches belongsTo relation app.
   *
   * @param {any} id entityrecord id
   *
   * @param {boolean} refresh 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `Entityrecord` object.)
   * </em>
   */
  public getApp(id: any, refresh: any = {}): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/entityrecords/:id/app";
    let _routeParams: any = {
      id: id
    };
    let _postBody: any = {};
    let _urlParams: any = {};
    if (refresh) _urlParams.refresh = refresh;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody);
    return result;
  }

  /**
   * Fetches belongsTo relation tenant.
   *
   * @param {any} id entityrecord id
   *
   * @param {boolean} refresh 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `Entityrecord` object.)
   * </em>
   */
  public getTenant(id: any, refresh: any = {}): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/entityrecords/:id/tenant";
    let _routeParams: any = {
      id: id
    };
    let _postBody: any = {};
    let _urlParams: any = {};
    if (refresh) _urlParams.refresh = refresh;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody);
    return result;
  }

  /**
   * Fetches belongsTo relation entity.
   *
   * @param {any} id entityrecord id
   *
   * @param {boolean} refresh 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `Entityrecord` object.)
   * </em>
   */
  public getEntity(id: any, refresh: any = {}): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/entityrecords/:id/entity";
    let _routeParams: any = {
      id: id
    };
    let _postBody: any = {};
    let _urlParams: any = {};
    if (refresh) _urlParams.refresh = refresh;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody);
    return result;
  }

  /**
   * Find a related item by id for entityrecordhistory.
   *
   * @param {any} id entityrecord id
   *
   * @param {any} fk Foreign key for entityrecordhistory
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `Entityrecord` object.)
   * </em>
   */
  public findByIdEntityrecordhistory(id: any, fk: any): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/entityrecords/:id/entityrecordhistory/:fk";
    let _routeParams: any = {
      id: id,
      fk: fk
    };
    let _postBody: any = {};
    let _urlParams: any = {};
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody);
    return result;
  }

  /**
   * Delete a related item by id for entityrecordhistory.
   *
   * @param {any} id entityrecord id
   *
   * @param {any} fk Foreign key for entityrecordhistory
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * This method returns no data.
   */
  public destroyByIdEntityrecordhistory(id: any, fk: any): Observable<any> {
    let _method: string = "DELETE";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/entityrecords/:id/entityrecordhistory/:fk";
    let _routeParams: any = {
      id: id,
      fk: fk
    };
    let _postBody: any = {};
    let _urlParams: any = {};
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody);
    return result;
  }

  /**
   * Update a related item by id for entityrecordhistory.
   *
   * @param {any} id entityrecord id
   *
   * @param {any} fk Foreign key for entityrecordhistory
   *
   * @param {object} data Request data.
   *
   * This method expects a subset of model properties as request parameters.
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `Entityrecord` object.)
   * </em>
   */
  public updateByIdEntityrecordhistory(id: any, fk: any, data: any = {}): Observable<any> {
    let _method: string = "PUT";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/entityrecords/:id/entityrecordhistory/:fk";
    let _routeParams: any = {
      id: id,
      fk: fk
    };
    let _postBody: any = {
      data: data
    };
    let _urlParams: any = {};
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody);
    return result;
  }

  /**
   * Queries entityrecordhistory of entityrecord.
   *
   * @param {any} id entityrecord id
   *
   * @param {object} filter 
   *
   * @returns {object[]} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `Entityrecord` object.)
   * </em>
   */
  public getEntityrecordhistory(id: any, filter: LoopBackFilter = {}): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/entityrecords/:id/entityrecordhistory";
    let _routeParams: any = {
      id: id
    };
    let _postBody: any = {};
    let _urlParams: any = {};
    if (filter) _urlParams.filter = filter;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody);
    return result;
  }

  /**
   * Creates a new instance in entityrecordhistory of this model.
   *
   * @param {any} id entityrecord id
   *
   * @param {object} data Request data.
   *
   * This method expects a subset of model properties as request parameters.
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `Entityrecord` object.)
   * </em>
   */
  public createEntityrecordhistory(id: any, data: any = {}): Observable<any> {
    let _method: string = "POST";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/entityrecords/:id/entityrecordhistory";
    let _routeParams: any = {
      id: id
    };
    let _postBody: any = {
      data: data
    };
    let _urlParams: any = {};
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody);
    return result;
  }

  /**
   * Deletes all entityrecordhistory of this model.
   *
   * @param {any} id entityrecord id
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * This method returns no data.
   */
  public deleteEntityrecordhistory(id: any): Observable<any> {
    let _method: string = "DELETE";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/entityrecords/:id/entityrecordhistory";
    let _routeParams: any = {
      id: id
    };
    let _postBody: any = {};
    let _urlParams: any = {};
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody);
    return result;
  }

  /**
   * Counts entityrecordhistory of entityrecord.
   *
   * @param {any} id entityrecord id
   *
   * @param {object} where Criteria to match model instances
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * Data properties:
   *
   *  - `count` – `{number}` - 
   */
  public countEntityrecordhistory(id: any, where: any = {}): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/entityrecords/:id/entityrecordhistory/count";
    let _routeParams: any = {
      id: id
    };
    let _postBody: any = {};
    let _urlParams: any = {};
    if (where) _urlParams.where = where;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody);
    return result;
  }

  /**
   * Patch an existing model instance or insert a new one into the data source.
   *
   * @param {object} data Request data.
   *
   *  - `data` – `{object}` - Model instance data
   *
   *  - `options` – `{object}` - 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `Entityrecord` object.)
   * </em>
   */
  public patchOrCreate(data: any = {}, options: any = {}): Observable<any> {
    let _method: string = "PATCH";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/entityrecords";
    let _routeParams: any = {};
    let _postBody: any = {
      data: data
    };
    let _urlParams: any = {};
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody);
    return result;
  }

  /**
   * Patch attributes for a model instance and persist it into the data source.
   *
   * @param {any} id entityrecord id
   *
   * @param {object} data Request data.
   *
   * This method expects a subset of model properties as request parameters.
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `Entityrecord` object.)
   * </em>
   */
  public patchAttributes(id: any, data: any = {}): Observable<any> {
    let _method: string = "PATCH";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/entityrecords/:id";
    let _routeParams: any = {
      id: id
    };
    let _postBody: any = {
      data: data
    };
    let _urlParams: any = {};
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {object} data Request data.
   *
   *  - `entityid` – `{string}` - 
   *
   *  - `data` – `{any}` - 
   *
   *  - `parentid` – `{string}` - 
   *
   *  - `applyformula` – `{boolean}` - 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `Entityrecord` object.)
   * </em>
   */
  public bulkCreate(entityid: any, data: any, parentid: any = {}, applyformula: any = {}): Observable<any> {
    let _method: string = "POST";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/entityrecords/bulkCreate/:entityid";
    let _routeParams: any = {};
    let _postBody: any = {
      data: data
    };
    let _urlParams: any = {};
    if (entityid) _urlParams.entityid = entityid;
    if (parentid) _urlParams.parentid = parentid;
    if (applyformula) _urlParams.applyformula = applyformula;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {object} data Request data.
   *
   *  - `id` – `{string}` - 
   *
   *  - `data` – `{object}` - 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `Entityrecord` object.)
   * </em>
   */
  public updateattributes(id: any, data: any): Observable<any> {
    let _method: string = "POST";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/entityrecords/:id/updateattributes";
    let _routeParams: any = {
      id: id
    };
    let _postBody: any = {
      data: data
    };
    let _urlParams: any = {};
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {string} id 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * Data properties:
   *
   *  - `response` – `{object}` - 
   */
  public customAction(id: any): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/entityrecords/customaction/:id";
    let _routeParams: any = {
      id: id
    };
    let _postBody: any = {};
    let _urlParams: any = {};
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {string} id 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * Data properties:
   *
   *  - `response` – `{object}` - 
   */
  public customActions(id: any): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/entityrecords/customactions/:id";
    let _routeParams: any = {
      id: id
    };
    let _postBody: any = {};
    let _urlParams: any = {};
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {string} id 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * Data properties:
   *
   *  - `response` – `{object}` - 
   */
  public findByIdProcessed(id: any): Observable<Entityrecord> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/entityrecords/full/:id";
    let _routeParams: any = {
      id: id
    };
    let _postBody: any = {};
    let _urlParams: any = {};
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody);
    return result.map((instance: Entityrecord) => new Entityrecord(instance));
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {string} id 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * Data properties:
   *
   *  - `response` – `{object}` - 
   */
  public findByIdforEdit(id: any): Observable<Entityrecord> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/entityrecords/edit/:id";
    let _routeParams: any = {
      id: id
    };
    let _postBody: any = {};
    let _urlParams: any = {};
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody);
    return result.map((instance: Entityrecord) => new Entityrecord(instance));
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {object} data Request data.
   *
   *  - `appid` – `{string}` - 
   *
   *  - `entityid` – `{string}` - 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `Entityrecord` object.)
   * </em>
   */
  public refreshAccounts(appid: any, entityid: any): Observable<any> {
    let _method: string = "POST";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/entityrecords/refreshAccounts/:appid/:entityid";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (appid) _urlParams.appid = appid;
    if (entityid) _urlParams.entityid = entityid;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody);
    return result;
  }

  /**
   * Find all instances of the model matched by filter from the data source.
   *
   * @param {object} filter Filter defining fields, where, aggregate, order, offset, and limit. Alternate is to provide the entire pipeline as pipeline
   *
   * @param {object} options options
   *
   * @returns {object[]} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `Entityrecord` object.)
   * </em>
   */
  public aggregate(filter: LoopBackFilter = {}, options: any = {}): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/entityrecords/aggregate";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (filter) _urlParams.filter = filter;
    if (options) _urlParams.options = options;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {string} range hourly, daily, weekly, monthly, yearly, custom
   *
   * @param {object} custom {"start": date, "end": date }
   *
   * @param {object} where where filter 
   *
   * @param {string} groupBy group by filter 
   *
   * @returns {object[]} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `Entityrecord` object.)
   * </em>
   */
  public stats(range: any, custom: any = {}, where: any = {}, groupBy: any = {}): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/entityrecords/stats";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (range) _urlParams.range = range;
    if (custom) _urlParams.custom = custom;
    if (where) _urlParams.where = where;
    if (groupBy) _urlParams.groupBy = groupBy;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {string} id 
   *
   * @param {string} customerid 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * Data properties:
   *
   *  - `response` – `{object}` - 
   */
  public restaurantById(id: any, customerid: any = {}): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/entityrecords/restaurant/:id";
    let _routeParams: any = {
      id: id
    };
    let _postBody: any = {};
    let _urlParams: any = {};
    if (customerid) _urlParams.customerid = customerid;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {string} appId 
   *
   * @param {object} geopoint 
   *
   * @param {boolean} foodcourt 
   *
   * @param {any} cuisines 
   *
   * @param {string} priceslot 
   *
   * @param {string} customerid 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * Data properties:
   *
   *  - `response` – `{object}` - 
   */
  public restaurant(appId: any, geopoint: any = {}, foodcourt: any = {}, cuisines: any = {}, priceslot: any = {}, customerid: any = {}): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/entityrecords/restaurant";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (appId) _urlParams.appId = appId;
    if (geopoint) _urlParams.geopoint = geopoint;
    if (foodcourt) _urlParams.foodcourt = foodcourt;
    if (cuisines) _urlParams.cuisines = cuisines;
    if (priceslot) _urlParams.priceslot = priceslot;
    if (customerid) _urlParams.customerid = customerid;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {string} restaurantid 
   *
   * @param {boolean} addon 
   *
   * @param {boolean} includeinactive 
   *
   * @param {string} customerid 
   *
   * @param {number} skip 
   *
   * @param {number} limit 
   *
   * @param {string} sort 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `Entityrecord` object.)
   * </em>
   */
  public restaurantMenuItems(restaurantid: any, addon: any = {}, includeinactive: any = {}, customerid: any = {}, skip: any = {}, limit: any = {}, sort: any = {}): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/entityrecords/restaurant/:restaurantid/menuitem";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (restaurantid) _urlParams.restaurantid = restaurantid;
    if (addon) _urlParams.addon = addon;
    if (includeinactive) _urlParams.includeinactive = includeinactive;
    if (customerid) _urlParams.customerid = customerid;
    if (skip) _urlParams.skip = skip;
    if (limit) _urlParams.limit = limit;
    if (sort) _urlParams.sort = sort;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {object} data Request data.
   *
   *  - `restaurantid` – `{string}` - 
   *
   *  - `data` – `{object}` - 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `Entityrecord` object.)
   * </em>
   */
  public updateRestaurantMenuItems(restaurantid: any, data: any): Observable<any> {
    let _method: string = "POST";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/entityrecords/restaurant/:restaurantid/menuitem";
    let _routeParams: any = {};
    let _postBody: any = {
      data: data
    };
    let _urlParams: any = {};
    if (restaurantid) _urlParams.restaurantid = restaurantid;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {string} restaurantid 
   *
   * @param {string} menuitemid 
   *
   * @param {string} customerid 
   *
   * @param {boolean} includeinactive 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `Entityrecord` object.)
   * </em>
   */
  public restaurantMenuItem(restaurantid: any, menuitemid: any, customerid: any = {}, includeinactive: any = {}): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/entityrecords/restaurant/:restaurantid/menuitem/:menuitemid";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (restaurantid) _urlParams.restaurantid = restaurantid;
    if (menuitemid) _urlParams.menuitemid = menuitemid;
    if (customerid) _urlParams.customerid = customerid;
    if (includeinactive) _urlParams.includeinactive = includeinactive;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {object} data Request data.
   *
   *  - `restaurantid` – `{string}` - 
   *
   *  - `menuitemid` – `{string}` - 
   *
   *  - `data` – `{object}` - 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `Entityrecord` object.)
   * </em>
   */
  public updateRestaurantMenuItem(restaurantid: any, menuitemid: any, data: any): Observable<any> {
    let _method: string = "POST";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/entityrecords/restaurant/:restaurantid/menuitem/:menuitemid";
    let _routeParams: any = {};
    let _postBody: any = {
      data: data
    };
    let _urlParams: any = {};
    if (restaurantid) _urlParams.restaurantid = restaurantid;
    if (menuitemid) _urlParams.menuitemid = menuitemid;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {string} customerid 
   *
   * @param {string} restaurantid 
   *
   * @param {string} foodcourtid 
   *
   * @param {string} tableid 
   *
   * @param {any} orderstatuses 
   *
   * @param {boolean} paid 
   *
   * @param {string} updatedAt 
   *
   * @param {string} createdAt 
   *
   * @param {boolean} loadrelationrecord 
   *
   * @param {number} skip 
   *
   * @param {number} limit 
   *
   * @param {string} sort 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `Entityrecord` object.)
   * </em>
   */
  public foodorders(customerid: any = {}, restaurantid: any = {}, foodcourtid: any = {}, tableid: any = {}, orderstatuses: any = {}, paid: any = {}, updatedAt: any = {}, createdAt: any = {}, loadrelationrecord: any = {}, skip: any = {}, limit: any = {}, sort: any = {}): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/entityrecords/foodorder";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (customerid) _urlParams.customerid = customerid;
    if (restaurantid) _urlParams.restaurantid = restaurantid;
    if (foodcourtid) _urlParams.foodcourtid = foodcourtid;
    if (tableid) _urlParams.tableid = tableid;
    if (orderstatuses) _urlParams.orderstatuses = orderstatuses;
    if (paid) _urlParams.paid = paid;
    if (updatedAt) _urlParams.updatedAt = updatedAt;
    if (createdAt) _urlParams.createdAt = createdAt;
    if (loadrelationrecord) _urlParams.loadrelationrecord = loadrelationrecord;
    if (skip) _urlParams.skip = skip;
    if (limit) _urlParams.limit = limit;
    if (sort) _urlParams.sort = sort;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {string} id 
   *
   * @param {string} restaurantid 
   *
   * @param {string} foodcourtid 
   *
   * @param {string} updatedAt 
   *
   * @param {boolean} loadrelationrecord 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `Entityrecord` object.)
   * </em>
   */
  public foodorderById(id: any, restaurantid: any = {}, foodcourtid: any = {}, updatedAt: any = {}, loadrelationrecord: any = {}): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/entityrecords/foodorder/:id";
    let _routeParams: any = {
      id: id
    };
    let _postBody: any = {};
    let _urlParams: any = {};
    if (restaurantid) _urlParams.restaurantid = restaurantid;
    if (foodcourtid) _urlParams.foodcourtid = foodcourtid;
    if (updatedAt) _urlParams.updatedAt = updatedAt;
    if (loadrelationrecord) _urlParams.loadrelationrecord = loadrelationrecord;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {object} data Request data.
   *
   * This method expects a subset of model properties as request parameters.
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `Entityrecord` object.)
   * </em>
   */
  public createRestaurantOrder(data: any): Observable<any> {
    let _method: string = "POST";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/entityrecords/foodorder";
    let _routeParams: any = {};
    let _postBody: any = {
      data: data
    };
    let _urlParams: any = {};
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {object} data Request data.
   *
   *  - `id` – `{string}` - 
   *
   *  - `data` – `{object}` - 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `Entityrecord` object.)
   * </em>
   */
  public updateRestaurantOrder(id: any, data: any): Observable<any> {
    let _method: string = "PUT";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/entityrecords/foodorder/:id";
    let _routeParams: any = {
      id: id
    };
    let _postBody: any = {
      data: data
    };
    let _urlParams: any = {};
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {string} restaurantid 
   *
   * @param {any} statuses 
   *
   * @param {number} skip 
   *
   * @param {number} limit 
   *
   * @param {string} sort 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `Entityrecord` object.)
   * </em>
   */
  public restaurantTables(restaurantid: any, statuses: any = {}, skip: any = {}, limit: any = {}, sort: any = {}): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/entityrecords/restaurant/:restaurantid/table";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (restaurantid) _urlParams.restaurantid = restaurantid;
    if (statuses) _urlParams.statuses = statuses;
    if (skip) _urlParams.skip = skip;
    if (limit) _urlParams.limit = limit;
    if (sort) _urlParams.sort = sort;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {object} data Request data.
   *
   *  - `id` – `{string}` - 
   *
   *  - `restaurantid` – `{string}` - 
   *
   *  - `data` – `{object}` - 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `Entityrecord` object.)
   * </em>
   */
  public updateRestaurantTableStatus(id: any, restaurantid: any, data: any): Observable<any> {
    let _method: string = "POST";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/entityrecords/restaurant/:restaurantid/table/:id";
    let _routeParams: any = {
      id: id
    };
    let _postBody: any = {
      data: data
    };
    let _urlParams: any = {};
    if (restaurantid) _urlParams.restaurantid = restaurantid;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {string} customerid 
   *
   * @param {string} restaurantid 
   *
   * @param {any} statuses 
   *
   * @param {number} skip 
   *
   * @param {number} limit 
   *
   * @param {string} sort 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `Entityrecord` object.)
   * </em>
   */
  public restauranttablerequests(customerid: any = {}, restaurantid: any, statuses: any = {}, skip: any = {}, limit: any = {}, sort: any = {}): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/entityrecords/restaurant/:restaurantid/tableassignmentrequest";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (customerid) _urlParams.customerid = customerid;
    if (restaurantid) _urlParams.restaurantid = restaurantid;
    if (statuses) _urlParams.statuses = statuses;
    if (skip) _urlParams.skip = skip;
    if (limit) _urlParams.limit = limit;
    if (sort) _urlParams.sort = sort;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {string} customerid 
   *
   * @param {string} restaurantid 
   *
   * @param {any} statuses 
   *
   * @param {number} skip 
   *
   * @param {number} limit 
   *
   * @param {string} sort 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `Entityrecord` object.)
   * </em>
   */
  public customerTableRequests(customerid: any, restaurantid: any = {}, statuses: any = {}, skip: any = {}, limit: any = {}, sort: any = {}): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/entityrecords/restaurantcustomer/:customerid/tableassignmentrequest";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (customerid) _urlParams.customerid = customerid;
    if (restaurantid) _urlParams.restaurantid = restaurantid;
    if (statuses) _urlParams.statuses = statuses;
    if (skip) _urlParams.skip = skip;
    if (limit) _urlParams.limit = limit;
    if (sort) _urlParams.sort = sort;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {object} data Request data.
   *
   *  - `restaurantid` – `{string}` - 
   *
   *  - `data` – `{object}` - 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `Entityrecord` object.)
   * </em>
   */
  public createRestaurantTableRequest(restaurantid: any, data: any): Observable<any> {
    let _method: string = "POST";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/entityrecords/restaurant/:restaurantid/tableassignmentrequest";
    let _routeParams: any = {};
    let _postBody: any = {
      data: data
    };
    let _urlParams: any = {};
    if (restaurantid) _urlParams.restaurantid = restaurantid;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {object} data Request data.
   *
   *  - `requestid` – `{string}` - 
   *
   *  - `restaurantid` – `{string}` - 
   *
   *  - `data` – `{object}` - 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `Entityrecord` object.)
   * </em>
   */
  public updateRestaurantTableRequest(requestid: any, restaurantid: any, data: any): Observable<any> {
    let _method: string = "POST";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/entityrecords/restaurant/:restaurantid/tableassignmentrequest/:requestid";
    let _routeParams: any = {};
    let _postBody: any = {
      data: data
    };
    let _urlParams: any = {};
    if (requestid) _urlParams.requestid = requestid;
    if (restaurantid) _urlParams.restaurantid = restaurantid;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {string} phoneno 
   *
   * @param {string} email 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `Entityrecord` object.)
   * </em>
   */
  public identifyCustomer(phoneno: any, email: any = {}): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/entityrecords/restaurantcustomer";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (phoneno) _urlParams.phoneno = phoneno;
    if (email) _urlParams.email = email;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {object} data Request data.
   *
   * This method expects a subset of model properties as request parameters.
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `Entityrecord` object.)
   * </em>
   */
  public identifyOrRegisterCustomer(data: any): Observable<any> {
    let _method: string = "POST";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/entityrecords/restaurantcustomer";
    let _routeParams: any = {};
    let _postBody: any = {
      data: data
    };
    let _urlParams: any = {};
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {object} data Request data.
   *
   *  - `id` – `{string}` - 
   *
   *  - `data` – `{object}` - 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `Entityrecord` object.)
   * </em>
   */
  public updateRestaurantCustomer(id: any, data: any): Observable<any> {
    let _method: string = "POST";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/entityrecords/restaurantcustomer/:id";
    let _routeParams: any = {
      id: id
    };
    let _postBody: any = {
      data: data
    };
    let _urlParams: any = {};
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {string} customerid 
   *
   * @param {string} orderid 
   *
   * @param {string} transactiontype 
   *
   * @param {number} limit 
   *
   * @param {number} skip 
   *
   * @param {string} sort 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `Entityrecord` object.)
   * </em>
   */
  public getGokashCreditTransactions(customerid: any, orderid: any = {}, transactiontype: any = {}, limit: any = {}, skip: any = {}, sort: any = {}): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/entityrecords/restaurantcustomer/:customerid/gokashcredittransaction";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (customerid) _urlParams.customerid = customerid;
    if (orderid) _urlParams.orderid = orderid;
    if (transactiontype) _urlParams.transactiontype = transactiontype;
    if (limit) _urlParams.limit = limit;
    if (skip) _urlParams.skip = skip;
    if (sort) _urlParams.sort = sort;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {string} restaurantid 
   *
   * @param {string} foodcourtid 
   *
   * @param {number} limit 
   *
   * @param {number} skip 
   *
   * @param {string} sort 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `Entityrecord` object.)
   * </em>
   */
  public getGoKhanaPromotions(restaurantid: any = {}, foodcourtid: any = {}, limit: any = {}, skip: any = {}, sort: any = {}): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/entityrecords/promotion";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (restaurantid) _urlParams.restaurantid = restaurantid;
    if (foodcourtid) _urlParams.foodcourtid = foodcourtid;
    if (limit) _urlParams.limit = limit;
    if (skip) _urlParams.skip = skip;
    if (sort) _urlParams.sort = sort;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {string} restaurantid 
   *
   * @param {number} limit 
   *
   * @param {number} skip 
   *
   * @param {string} sort 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `Entityrecord` object.)
   * </em>
   */
  public getGokashCreditDiscounts(restaurantid: any = {}, limit: any = {}, skip: any = {}, sort: any = {}): Observable<any> {
    let _method: string = "GET";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/entityrecords/gokashcreditdiscount";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (restaurantid) _urlParams.restaurantid = restaurantid;
    if (limit) _urlParams.limit = limit;
    if (skip) _urlParams.skip = skip;
    if (sort) _urlParams.sort = sort;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {object} data Request data.
   *
   *  - `appid` – `{string}` - 
   *
   *  - `data` – `{object}` - 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `Entityrecord` object.)
   * </em>
   */
  public generatechecksum(appid: any, data: any): Observable<any> {
    let _method: string = "POST";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/entityrecords/:appid/generatechecksum";
    let _routeParams: any = {};
    let _postBody: any = {
      data: data
    };
    let _urlParams: any = {};
    if (appid) _urlParams.appid = appid;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {object} data Request data.
   *
   *  - `appid` – `{string}` - 
   *
   *  - `data` – `{object}` - 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `Entityrecord` object.)
   * </em>
   */
  public verifychecksum(appid: any, data: any): Observable<any> {
    let _method: string = "POST";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/entityrecords/:appid/verifychecksum";
    let _routeParams: any = {};
    let _postBody: any = {
      data: data
    };
    let _urlParams: any = {};
    if (appid) _urlParams.appid = appid;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody);
    return result;
  }

  /**
   * Creates a new instance in entityrecordhistory of this model.
   *
   * @param {any} id entityrecord id
   *
   * @param {object} data Request data.
   *
   * This method expects a subset of model properties as request parameters.
   *
   * @returns {object[]} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * <em>
   * (The remote method definition does not provide any description.
   * This usually means the response is a `Entityrecord` object.)
   * </em>
   */
  public createManyEntityrecordhistory(id: any, data: any[] = []): Observable<any> {
    let _method: string = "POST";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
      "/entityrecords/:id/entityrecordhistory";
    let _routeParams: any = {
      id: id
    };
    let _postBody: any = {
      data: data
    };
    let _urlParams: any = {};
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody);
    return result;
  }

  /**
   * The name of the model represented by this $resource,
   * i.e. `Entityrecord`.
   */
  public getModelName() {
    return "Entityrecord";
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/services/custom/Entityrecord.ts